import {FunctionComponent, SVGProps} from 'react';

import {ReactComponent as FailIcon} from 'shared/assets/fail.svg';
import {ReactComponent as SuccessIcon} from 'shared/assets/success.svg';

export const StatusCodeIcons : Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
    C: SuccessIcon,
    E: FailIcon,
};
